import { Button, Col, Dropdown, Form, Input, Menu, Modal, Row, Select, Tabs } from 'antd'
import React, { useEffect, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux';
import { EmptyData } from './EmptyData';
import { Loading } from './Loading';
import styles from "../../Rtd/style/rtd.module.css";
import { FileImageOutlined, FileTextOutlined, InfoCircleOutlined, MoreOutlined } from '@ant-design/icons';
import { FaRegFilePdf } from "react-icons/fa";
import RtdLegend from './RtdLegend';
import { IoCloudUploadOutline } from "react-icons/io5";
import UploadPdfDoc from '../../PropertyComp/components/UploadPdfDoc';
import { transactionLaneDataHandle } from '../../Rtd/state/actions';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import moment from "moment";
import PropertyDocsDragger from '../../PropertyComp/components/PropertyDocsDragger';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import PropertyDocsTable from '../../PropertyComp/components/PropertyDocsTable';
import { PropertyHandlers } from '../../PropertyComp/state/actions';
import { formatAddress, formatPhoneNumber } from '../utils/extraFunctions';
import { commonOfferTableFunc, commonStatusFunc, getBackgroundColor, getOfferTableColor } from '../commondata/commonData';
import NumberFormat from 'react-number-format';
import PhoneInput from 'react-phone-input-2';
const { TabPane } = Tabs;
const { Option } = Select;

const ChecklistTable = ({ section, checklistTable, setChecklistTable, client, delegateSide, currentAgentDetails, origin, item }) => {
  const delegate = (section === "DELEGATE");
  const { checklistData, checklistDataLoading, callCheckList, transactionReportData, sourceOfBusinessData, sourceOfBusinessLoading, checkListDataOnOffer } = useSelector((state) => state.rtdTransactionLane, shallowEqual);
  let { updatedPropertyDoc, uploadedPdfDocSuccess, propertyDocs, propertDocsLoading } = useSelector((state) => state.PropertyReducer, shallowEqual);

  const dispatch = useDispatch();
  const location = useLocation();

  const rowStyle = {
    paddingBottom: '8px'
  };

  const labelStyle = {
    fontWeight: 'bold',
    fontSize: '14px',
    color: '#555',
  };

  const valueStyle = {
    fontSize: '14px',
    color: '#000',
  };

  const cleanCurrency = (val) => {
    if (typeof val === "string") {
      return val.replace(/[^0-9.]/g, '');
    }
    return val;
  };

  const commonStatus = client === "SELLER" ? commonOfferTableFunc({ key: transactionReportData?.currentStatus }) : commonStatusFunc({ key: transactionReportData?.currentStatus });
  let statusLabel = client === "SELLER" ? getOfferTableColor({ key: commonStatus?.key, type: "TEXT" }) : getBackgroundColor({ key: commonStatus?.key, type: "TEXT" });

  const [form] = Form.useForm();
  const [referralForm] = Form.useForm();
  const [commissionForm] = Form.useForm();

  const [showlegend, setShowLegend] = useState(false);
  const [showPropertyDocUpload, setShowPropertyDocUpload] = useState(false);
  const [allData, setAllData] = useState({
    uploadPdfDoc: false,
    file: "",
    doraDocItem: {},
    ...(delegateSide
      ? {
        delegateSide: client === "SELLER" ? "SELLER" : "BUYER",
        delegateOwnerId: currentAgentDetails?._id,
      }
      : {}),
  });
  const [checkboxSelected, setCheckboxSelected] = useState([])

  const [agent, setAgent] = useState({
    agentDetails: {},
    sourceOfBusiness: null,
    referralSave: false,
    commissionSave: false,
  });
  const isWeb = true;

  const handleCancel = () => {
    setChecklistTable({ ...checklistTable, openTable: false })
  }

  const propertyInfo = () => {
    return <div style={{ padding: '0 10px' }}>
      <Row style={rowStyle}>
        <Col span={6} style={labelStyle}>
          Transaction:
        </Col>
        <Col span={18} style={valueStyle}>
          {/* {transactionReportData?.currentStatus || 'N/A'} */}
          {statusLabel?.value}
        </Col>
      </Row>
      <Row style={rowStyle}>
        <Col span={6} style={labelStyle}>
          Address:
        </Col>
        <Col span={18} style={valueStyle}>
          {transactionReportData?.address || 'N/A'}
        </Col>
      </Row>
      <Row style={rowStyle}>
        <Col span={6} style={labelStyle}>
          Property Type:
        </Col>
        <Col span={18} style={valueStyle}>
          {/* {item?.Owners || 'N/A'} */}
        </Col>
      </Row>
      <Row style={rowStyle}>
        <Col span={6} style={labelStyle}>
          Sales Price:
        </Col>
        <Col span={18} style={valueStyle}>
          {transactionReportData?.purchasePrice ? `$${transactionReportData?.purchasePrice}` : 'N/A'}
        </Col>

      </Row>
      <Row style={rowStyle}>
        <Col span={6} style={labelStyle}>
          Legal Description:
        </Col>
        <Col span={18} style={valueStyle}>
          {transactionReportData?.legalDescription || 'N/A'}
        </Col>
      </Row>
    </div>
  }

  const getStatusIcon = (ele, isUpload) => {
    if (ele?.signaturesVerified) {
      return <div className={styles.fullCircle} style={{ backgroundColor: "green" }} />;
    }

    const { signatureSequence, isAllBuyerSigned, isAllSellerSigned, isAllBuyerAgentsSigned, isAllSellerAgentsSigned } = ele;

    const buyerRequired = !!signatureSequence?.[0]?.buyer;
    const sellerRequired = !!signatureSequence?.[0]?.seller;
    const buyerAgentRequired = !!signatureSequence?.[0]?.buyerAgent;
    const sellerAgentRequired = !!signatureSequence?.[0]?.sellerAgent;

    const clientRequired = buyerRequired || sellerRequired;
    const agentRequired = buyerAgentRequired || sellerAgentRequired;

    const isClientSigned =
      (!buyerRequired || isAllBuyerSigned) &&
      (!sellerRequired || isAllSellerSigned);

    const isAgentSigned =
      (!buyerAgentRequired || isAllBuyerAgentsSigned) &&
      (!sellerAgentRequired || isAllSellerAgentsSigned);

    const isAllSigned = isClientSigned && isAgentSigned;

    const isAnyClientSigned =
      (buyerRequired && isAllBuyerSigned) ||
      (sellerRequired && isAllSellerSigned);

    const isAnyAgentSigned =
      (buyerAgentRequired && isAllBuyerAgentsSigned) ||
      (sellerAgentRequired && isAllSellerAgentsSigned);

    const isAnySigned = isAnyClientSigned || isAnyAgentSigned;
    const anySignaturesRequired = clientRequired || agentRequired;

    if (anySignaturesRequired) {
      if (isAllSigned) {
        return <div className={styles.fullCircle} style={{ backgroundColor: "green" }} />;
      } else if (isAnySigned) {
        return <div className={styles.fullCircle} style={{ backgroundColor: "yellow" }} />;
      } else {
        return <div className={styles.fullCircle} style={{ backgroundColor: "white" }} />;
      }
    }
    return null;
  };


  const handleAddDocument = () => {
    setShowPropertyDocUpload(true)
  }

  const handleOpenLegendModal = () => {
    setShowLegend(true)
  }

  const handleUploadNew = (ele) => {
    setAllData({
      ...allData,
      signatureOf: null,
      file: "",
      sourceOrigin: "CHECKLIST_UPLOAD_NEW",
      uploadPdfDoc: true,
      doraDocItem: ele,
    })
  }

  const handleModalCancel = () => {
    setAllData({
      uploadPdfDoc: false,
      doraDocItem: {},
      sourceOrigin: "",
      source: "",
      signatureOf: null,
      file: ""
    })
  }

  useEffect(() => {
    let unmounted = { value: false }
    let source = axios.CancelToken.source();
    const params = {
      ...(item?.offerId && !item.isSellingMatrix ? { offerId: item?.offerId } : {}),
      ...(item?.propertyId ? { propertyId: item?.propertyId } : {}),
      openFor: client === "SELLER" ? "SELLER_AGENT" : "BUYER_AGENT",
      ...(delegate ? { delegateSide: (item.isProperty) ? "SELLER" : "BUYER", delegateOwnerId: currentAgentDetails?._id } : {}),
      section: "PROPERTY_DOCS",
      ...(isWeb ? { isWeb: true } : {})
    };
    if (item?.offerId || item?.propertyId) {
      dispatch(PropertyHandlers.getPropertyDocsFun({ params, unmounted, source }));
    }
    dispatch(transactionLaneDataHandle.getChecklistData({ offerId: item?.offerId, propertyId: item?.propertyId, unmounted, source, delegateOwnerId: delegate && currentAgentDetails?._id, openFor: client === "SELLER" ? "SELLER" : "BUYER" }));
    dispatch(transactionLaneDataHandle.getSourceOfBusiness({ source, unmounted }))
    return () => {
      unmounted.value = true;
      source.cancel("Cancelling in cleanup");
    }
  }, [updatedPropertyDoc, uploadedPdfDocSuccess, callCheckList])

  const handleClose = () => {
    setShowPropertyDocUpload(false);
    setCheckboxSelected([])
  }

  const handleVerify = (offerData, clicked) => {
    dispatch(transactionLaneDataHandle.verifyUploadDoc({ clicked, offerData, signatureVerify: true }))
  }

  const urlShortningForDraft = (seller) => {
    if (seller?.ispdfClone || seller?.isPdf || (seller?.fileType === "IMAGE") || (seller?.fileType === "PDF")) {
      let fileUrl = seller?.resureSignedPdfLink ? seller?.resureSignedPdfLink : (seller?.pdfLink || seller?.fileUrl);
      window.open(fileUrl, "_blank").focus();
    } else {
      let buildData = {
        builtForId: currentAgentDetails?._id,
        key: currentAgentDetails?._id,
        builtForSection: "DOCUMENT",
        signable: true,
        openFor: client === "SELLER" ? "SELLER_AGENT" : "BUYER_AGENT",
        contractType: seller?.contractType,
        offerId: item?.offerId || null,
        documentId: seller?._id,
        contractId: seller?.contractId,
        token: localStorage.getItem("userAuth"),
        ...(delegate ? { delegateOwnerId: currentAgentDetails?._id } : {}),
      };
      dispatch(transactionLaneDataHandle.generateUrlIdAndRedirect({ buildData, currentPath: location?.pathname, delegateOwnerId: delegate && currentAgentDetails?._id }));
      localStorage.setItem("ComplianceChecklist", JSON.stringify(true))
    }
  };

  const handleRemoveDocument = (offerData, clicked) => {
    dispatch(transactionLaneDataHandle.verifyUploadDoc({ clicked, offerData, showInChecklist: false, remove: true }))
  }

  const handleEditDoc = (ele, origin) => {
    setAllData({ ...allData, uploadPdfDoc: true, file: origin === "add" ? ele?.fileName : ele?.name, signatureOf: ele?.signatureOf || [], doraDocItem: ele, sourceOrigin: "EDIT_CHECKLIST" });
  };

  const MenuItem = ({ ele, origin }) => {
    const shouldShowVerify =
      (origin === "upload" && ele?.isPdf && !ele?.signaturesVerified) ||
      (origin === "add" && ele?.isPropertyDoc && !ele?.signaturesVerified);

    const canEdit = (origin === "upload" && (ele?.pdfLink || ele.fileUrl)) || (origin === "add" && ele?.isPropertyDoc);

    return (
      <Menu>
        {canEdit && (
          <Menu.Item key="edit" onClick={() => handleEditDoc(ele, origin)}>
            Edit Document
          </Menu.Item>
        )}
        <Menu.Item key="remove" onClick={() => handleRemoveDocument(ele, origin)}>
          Remove document
        </Menu.Item>
        {shouldShowVerify && (
          <Menu.Item key="verify" onClick={() => handleVerify(ele, origin)}>
            Mark required signatures complete
          </Menu.Item>
        )}
      </Menu>
    );
  };

  const handleShowInChecklist = (ele, checked) => {
    dispatch(transactionLaneDataHandle.verifyUploadDoc({ showInChecklist: true, checked: checked, clicked: (ele?.fileType === "PDF" || ele?.fileType === "IMAGE") ? "add" : "upload", offerData: ele }))
    setCheckboxSelected([]);
  }

  const handleSourceSelect = () => {
    dispatch(transactionLaneDataHandle.updateSourceOfBusiness({ sourceOfBusiness: form.getFieldValue("sourceOfBusiness") ? { key: form.getFieldValue("sourceOfBusiness")?.value} : {}, openFor: client, offerId: item?.offerId || null }))
  }

  const handleReferralAgent = (values) => {
    let urlData = {
      referringAgentDetails: {
        ...(values?.firmName?.length ? { firmName: values?.firmName } : {}),
        ...(values?.firmLicense?.length ? { firmLicense: values?.firmLicense } : {}),
        ...(values?.address?.length ? { address: values?.address } : {}),
        ...(values?.fullName?.length ? { fullName: values?.fullName } : {}),
        ...(values?.license?.length ? { license: values?.license } : {}),
        ...(values?.email?.length ? { email: values?.email } : {}),
        ...(values?.phoneNumber?.length ? { phoneNumber: values?.phoneNumber } : {}),
        ...(values?.faxNumber?.length ? { faxNumber: values?.faxNumber } : {}),
      }
    }
    dispatch(transactionLaneDataHandle.updateReferringAgent({ urlData, openFor: client, offerId: item?.offerId || null, origin:"REFERRAL_AGENT" }))
    setAgent({ ...agent, referralSave: false })
  }

  const handleCommission = (values) => {
    const cleanedValues = {
      salePrice: cleanCurrency(values?.salePrice),
      grossCommission: cleanCurrency(values?.grossCommission),
      referral: cleanCurrency(values?.referral),
      charitableContribution: cleanCurrency(values?.charitableContribution),
      charity_1: cleanCurrency(values?.charity_1),
      charity_2: cleanCurrency(values?.charity_2),
    };

    let urlData = {
      commissionDistribution: {
        ...(cleanedValues?.salePrice ? { salePrice: cleanedValues?.salePrice } : {}),
        ...(cleanedValues?.grossCommission ? { grossCommission: cleanedValues?.grossCommission } : {}),
        ...(cleanedValues?.referral ? { referral: cleanedValues?.referral } : {}),
        ...(cleanedValues?.charitableContribution ? { charitableContribution: cleanedValues?.charitableContribution } : {}),
        ...(cleanedValues?.charity_1 ? { charity_1: cleanedValues?.charity_1 } : {}),
        ...(cleanedValues?.charity_2 ? { charity_2: cleanedValues?.charity_2 } : {}),
      }
    };
    dispatch(transactionLaneDataHandle.updateCommissionReport({
      urlData,
      openFor: client,
      offerId: item?.offerId || null,
      origin:"COMMISSION_REPORT"
    }));
    setAgent({ ...agent, commissionSave: false });
  };


  useEffect(() => {
    if(checkListDataOnOffer?.referringAgentDetails){
      referralForm?.setFieldsValue({
        firmName: checkListDataOnOffer?.referringAgentDetails?.firmName,
        firmLicense: checkListDataOnOffer?.referringAgentDetails?.firmLicense,
        address: checkListDataOnOffer?.referringAgentDetails?.address,
        fullName: checkListDataOnOffer?.referringAgentDetails?.fullName,
        license: checkListDataOnOffer?.referringAgentDetails?.license,
        phoneNumber: checkListDataOnOffer?.referringAgentDetails?.phoneNumber,
        faxNumber: checkListDataOnOffer?.referringAgentDetails?.faxNumber,
        email: checkListDataOnOffer?.referringAgentDetails?.email,
      })
    }
    if(checkListDataOnOffer?.commissionDistribution){
      commissionForm?.setFieldsValue({
        salePrice: checkListDataOnOffer?.commissionDistribution?.salePrice,
        grossCommission: checkListDataOnOffer?.commissionDistribution?.grossCommission,
        referral: checkListDataOnOffer?.commissionDistribution?.referral,
        charitableContribution: checkListDataOnOffer?.commissionDistribution?.charitableContribution,
        charity_1: checkListDataOnOffer?.commissionDistribution?.charity_1,
        charity_2: checkListDataOnOffer?.commissionDistribution?.charity_2,
      })
    }
    if(checkListDataOnOffer?.sourceOfBusiness){
      form?.setFieldsValue({
        sourceOfBusiness: checkListDataOnOffer?.sourceOfBusiness?.value
      })
    }
  },[checkListDataOnOffer])

  useEffect(() => {
    const isOpen = JSON.parse(localStorage.getItem("ComplianceChecklist"));
    if (isOpen) {
      localStorage.removeItem("ComplianceChecklist");
    }
  }, [])

  return (
    <>
      <RtdLegend setShowLegend={setShowLegend} showlegend={showlegend} seller={client} />

      <UploadPdfDoc selectedData={{ ...allData.doraDocItem, RTDInitiator: client, ...item }} allData={allData} setAllData={setAllData} handleModalCancel={handleModalCancel} open={allData?.uploadPdfDoc} getCoordinateItem={{ isProperty: client === "SELLER" }} source={"checklistTable"} />

      <Modal open={checklistTable?.openTable} onCancel={handleCancel} width={1020} footer={false} style={{ marginTop: "-50px" }}
        title={
          <div style={{ position: 'relative', width: '100%', textAlign: 'center' }}>
            <span className="commonModalTitle">Compliance Checklist</span>
            <InfoCircleOutlined
              style={{
                position: 'absolute',
                right: 25,
                top: '50%',
                transform: 'translateY(-50%)',
                fontSize: "22px",
                color: 'grey',
                cursor: 'pointer',
              }}
              onClick={handleOpenLegendModal}
            />
          </div>
        }
        bodyStyle={{ height: "calc(80vh - 2rem)", overflowY: "auto" }}>
        {checklistDataLoading ? <div style={{ margin: "auto" }}><Loading /></div> :

          checklistData?.length > 0 ?
            <>
              {propertyInfo()}
              <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "1rem", borderBottom: "1px solid #ccc", color: "white", background: "#2270B9" }}>
                DATES
              </div>
              <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                <table style={{ textAlign: "center", width: "100%", border: "1px solid black" }}>
                  <thead style={{ backgroundColor: "antiquewhite" }}>
                    <tr>
                      <th style={{ padding: "8px 16px" }}>Opening Date</th>
                      <th style={{ padding: "8px 16px" }}>Under Contract</th>
                      <th style={{ padding: "8px 16px" }}>Date of Transfer</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{transactionReportData?.openingDate}</td>
                      <td>{""}</td>
                      <td>{item?.newTransactionData?.ClosingDate}</td>
                    </tr>
                  </tbody>
                </table>
              </div>


              <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "1rem", borderBottom: "1px solid #ccc", color: "white", background: "#2270B9", marginTop: "20px" }}>
                COMPANY INFORMATION
              </div>
              <div >
                <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                  <div
                    style={{
                      display: "flex",
                      borderRadius: "8px",
                      overflow: "hidden",
                      width: "90%",
                      margin: "auto",
                      gap: "1px",
                    }}
                  >
                    {/* Seller Agents */}
                    <div style={{ flex: 1, padding: "16px", backgroundColor: "#f9f9f9" }}>
                      <div style={{ color: "orange", fontWeight: "bold", marginBottom: "12px" }}>
                        Listing Company
                      </div>

                      {transactionReportData?.sellerAgents?.map((agent, idx) => (
                        <div
                          key={`seller-${idx}`}
                          style={{
                            border: "1px solid #ddd",
                            borderRadius: "6px",
                            padding: "10px",
                            marginBottom: "16px",
                            backgroundColor: "#fff",
                          }}
                        >
                          {[
                            { label: "Brokerage Name:", value: agent?.firmName },
                            { label: "Brokerage ID:", value: agent?.firmLicense },
                            { label: "Address:", value: agent?.address },
                            { label: "Agent:", value: agent?.fullName },
                            { label: "Agent ID:", value: agent?.license },
                            { label: "Phone:", value: agent?.phoneNumber },
                            { label: "Fax:", value: agent?.faxNumber },
                            { label: "Email:", value: agent?.email },
                          ].map((field, index) => (
                            <div key={index} style={{ display: "flex", marginBottom: "6px" }}>
                              <span style={{ fontWeight: "bold", width: "140px", flexShrink: 0 }}>
                                {field.label}
                              </span>
                              <span>{field.value || ""}</span>
                            </div>
                          ))}
                        </div>
                      )
                      )}
                    </div>

                    {/* Divider */}
                    <div style={{ width: "1px", backgroundColor: "#ccc" }}></div>

                    {/* Buyer Agents */}
                    <div style={{ flex: 1, padding: "16px", backgroundColor: "#f9f9f9" }}>
                      <div style={{ color: "orange", fontWeight: "bold", marginBottom: "12px" }}>
                        Selling Company
                      </div>

                      {transactionReportData?.buyerAgents?.map((agent, idx) => (
                        <div
                          key={`buyer-${idx}`}
                          style={{
                            border: "1px solid #ddd",
                            borderRadius: "6px",
                            padding: "10px",
                            marginBottom: "16px",
                            backgroundColor: "#fff",
                          }}
                        >
                          {[
                            { label: "Brokerage Name:", value: agent?.firmName },
                            { label: "Brokerage ID:", value: agent?.firmLicense },
                            { label: "Address:", value: agent?.address },
                            { label: "Agent:", value: agent?.fullName },
                            { label: "Agent ID:", value: agent?.license },
                            { label: "Phone:", value: agent?.phoneNumber },
                            { label: "Fax:", value: agent?.faxNumber },
                            { label: "Email:", value: agent?.email },
                          ].map((field, index) => (
                            <div key={index} style={{ display: "flex", marginBottom: "6px" }}>
                              <span style={{ fontWeight: "bold", width: "140px", flexShrink: 0 }}>
                                {field.label}
                              </span>
                              <span>{field.value || ""}</span>
                            </div>
                          ))}
                        </div>
                      )
                      )}
                    </div>
                  </div>

                </div>

              </div>


              <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "1rem", borderBottom: "1px solid #ccc", color: "white", background: "#2270B9", marginTop: "20px" }}>
                BUYER INFORMATION
              </div>

              <div >

                {transactionReportData?.buyerIds?.map((buyer, index) => {
                  const sourceArray = buyer.isCorp ? buyer.signers : [buyer];

                  return sourceArray.map((b, subIndex) => (
                    <div
                      key={`${index}-${subIndex}`}
                      style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}
                    >
                      <div
                        style={{
                          display: "flex",
                          width: "90%",
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          overflow: "hidden",
                        }}
                      >
                        {/* Left Table */}
                        <div style={{ flex: 1, padding: "16px" }}>
                          <table style={{ width: "100%" }}>
                            <tbody>
                              <tr>
                                <td><strong>Buyer:</strong></td>
                                <td>
                                  <input
                                    value={b?.fullName || ""}
                                    disabled
                                    style={{ width: "100%" }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td><strong>Email:</strong></td>
                                <td>
                                  <input
                                    value={b?.personId?.email || ""}
                                    disabled
                                    style={{ width: "100%" }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td><strong>Address:</strong></td>
                                <td>
                                  <input
                                    value={formatAddress(b?.personId?.addressId) || ""}
                                    disabled
                                    style={{ width: "100%" }}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        {/* Divider */}
                        <div style={{ width: "1px", backgroundColor: "#ccc" }}></div>

                        {/* Right Table */}
                        <div style={{ flex: 1, padding: "16px" }}>
                          <table style={{ width: "100%" }}>
                            <tbody>
                              <tr>
                                <td><strong>Home Ph.:</strong></td>
                                <td>
                                  <input
                                    value={formatPhoneNumber(b?.personId?.homePhoneNumber?.phoneNumber) || ""}
                                    disabled
                                    style={{ width: "100%" }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td><strong>Fax/Work:</strong></td>
                                <td>
                                  <input
                                    value={formatPhoneNumber(b?.personId?.officePhoneNumber?.phoneNumber) || ""}
                                    disabled
                                    style={{ width: "100%" }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td><strong>Mobile Ph.:</strong></td>
                                <td>
                                  <input
                                    value={formatPhoneNumber(b?.personId?.mobilePhoneNumber?.phoneNumber) || ""}
                                    disabled
                                    style={{ width: "100%" }}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  ));
                })}



              </div>


              <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "1rem", borderBottom: "1px solid #ccc", color: "white", background: "#2270B9", marginTop: "20px" }}>
                SELLER INFORMATION
              </div>

              <div>
                {transactionReportData?.sellerIds?.map((buyer, index) => {
                  const sourceArray = buyer.isCorp ? buyer.signers : [buyer];

                  return sourceArray.map((b, subIndex) => (
                    <div
                      key={`${index}-${subIndex}`}
                      style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}
                    >
                      <div
                        style={{
                          display: "flex",
                          width: "90%",
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          overflow: "hidden",
                        }}
                      >
                        {/* Left Table */}
                        <div style={{ flex: 1, padding: "16px" }}>
                          <table style={{ width: "100%" }}>
                            <tbody>
                              <tr>
                                <td><strong>Seller:</strong></td>
                                <td>
                                  <input
                                    value={b?.fullName || ""}
                                    disabled
                                    style={{ width: "100%" }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td><strong>Email:</strong></td>
                                <td>
                                  <input
                                    value={b?.personId?.email || ""}
                                    disabled
                                    style={{ width: "100%" }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td><strong>Address:</strong></td>
                                <td>
                                  <input
                                    value={formatAddress(b?.personId?.addressId) || ""}
                                    disabled
                                    style={{ width: "100%" }}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        {/* Divider */}
                        <div style={{ width: "1px", backgroundColor: "#ccc" }}></div>

                        {/* Right Table */}
                        <div style={{ flex: 1, padding: "16px" }}>
                          <table style={{ width: "100%" }}>
                            <tbody>
                              <tr>
                                <td><strong>Home Ph.:</strong></td>
                                <td>
                                  <input
                                    value={formatPhoneNumber(b?.personId?.homePhoneNumber?.phoneNumber) || ""}
                                    disabled
                                    style={{ width: "100%" }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td><strong>Fax/Work:</strong></td>
                                <td>
                                  <input
                                    value={formatPhoneNumber(b?.personId?.officePhoneNumber?.phoneNumber) || ""}
                                    disabled
                                    style={{ width: "100%" }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td><strong>Mobile Ph.:</strong></td>
                                <td>
                                  <input
                                    value={formatPhoneNumber(b?.personId?.mobilePhoneNumber?.phoneNumber) || ""}
                                    disabled
                                    style={{ width: "100%" }}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  ));
                })}

              </div>


              <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "1rem", borderBottom: "1px solid #ccc", color: "white", background: "#2270B9", marginTop: "20px" }}>
                TITLE COMPANY INFORMATION
              </div>

              <div>
                <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                  <div style={{ display: "flex", width: "90%", border: "1px solid #ccc", borderRadius: "8px", overflow: "hidden" }}>

                    {/* Left Table */}
                    <div style={{ flex: 1, padding: "16px" }}>
                      <table style={{ width: "100%" }}>
                        <tbody>
                          <tr>
                            <td><strong>Title Company:</strong></td>
                            <td>
                              <input
                                value={transactionReportData?.titleCompanyData?.titleOfficeName || transactionReportData?.titleCompanyData?.titleCompanyName || ""}
                                disabled
                                style={{ width: "100%" }}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td><strong>Address:</strong></td>
                            <td>
                              <input
                                value={transactionReportData?.titleCompanyData?.titleOfficeAddress || ""}
                                disabled
                                style={{ width: "100%" }}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td><strong>Phone:</strong></td>
                            <td>
                              <input
                                value={formatPhoneNumber(transactionReportData?.titleCompanyData?.titleOfficePhoneNo) || ""}
                                disabled
                                style={{ width: "100%" }}
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    {/* Divider */}
                    <div style={{ width: "1px", backgroundColor: "#ccc" }}></div>

                    {/* Right Table */}
                    <div style={{ flex: 1, padding: "16px" }}>
                      <table style={{ width: "100%" }}>
                        <tbody>
                          <tr>
                            <td><strong>Closer:</strong></td>
                            <td>
                              <input
                                value={transactionReportData?.titleCompanyData?.titleCloserName || ""}
                                disabled
                                style={{ width: "100%" }}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td><strong>Closer Address:</strong></td>
                            <td>
                              <input
                                value={transactionReportData?.titleCompanyData?.titleCloserAddress || ""}
                                disabled
                                style={{ width: "100%" }}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td><strong>Closer Ph:</strong></td>
                            <td>
                              <input
                                value={formatPhoneNumber(transactionReportData?.titleCompanyData?.titleCloserPhone) || ""}
                                disabled
                                style={{ width: "100%" }}
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                  </div>
                </div>

              </div>


              <table border="2" style={{ width: "100%", margin: "20px 0 20px 0" }}>
                <thead className="licenseTable">
                  <tr style={{ backgroundColor: "" }}>
                    <th colSpan="3" style={{ textAlign: "center" }}>Transaction Documents</th>
                    <th colSpan="4" style={{ textAlign: "center" }}>Signatures</th>
                    <th colspan="1" style={{ textAlign: "center" }}>Status</th>
                  </tr>
                  <tr>
                    <th style={{ borderTop: "1px solid black" }}>Created/Uploaded Date</th>
                    <th style={{ borderTop: "1px solid black" }}>Completed/Verified Date</th>
                    <th>Documents</th>
                    <th>Buyer(s)</th>
                    <th>Buyer Agent(s)</th>
                    <th>Seller(s)</th>
                    <th>Seller Agent(s)</th>
                    <th style={{ borderTop: "1px solid black" }}>Complete</th>
                  </tr>
                </thead>
                <tbody style={{ textAlign: "center" }}>
                  {checklistData?.map((ele, idx) => {
                    const isUpload = ele?.isUpload || false;
                    if (!ele?.isPropertyDoc) {
                      return (
                        <tr key={ele.contractId}>
                          <td>{ele?.createdAt ? moment(ele?.createdAt)?.format("MM/DD/YYYY hh:mm A") : ""}</td>
                          <td>{!isUpload && ele?.latestSignatureTimeStamp ? moment(ele?.latestSignatureTimeStamp)?.format("MM/DD/YYYY hh:mm A") : ele?.signaturesVerified && ele?.signaturesVerifiedAt ? moment(ele?.signaturesVerifiedAt)?.format("MM/DD/YYYY hh:mm A") : ""}</td>
                          <td>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                              {ele.fileType === "IMAGE" ? (
                                <FileImageOutlined
                                  style={{
                                    color: "#ecd540",
                                    marginTop: "5px",
                                    marginRight: "5px",
                                    fontSize: "18px",
                                  }}
                                />
                              ) : ele.fileType === "PDF" || ele.pdfLink || ele?.fileUrl ? (
                                <FaRegFilePdf
                                  style={{
                                    color: "red",
                                    marginTop: "5px",
                                    marginRight: "5px",
                                    fontSize: "18px",
                                  }}
                                />
                              ) : (
                                <FileTextOutlined
                                  style={{
                                    color: "#74b3ed",
                                    marginRight: "5px",
                                    fontSize: "18px",
                                  }}
                                />
                              )}
                              <span className={!isUpload ? styles.documentName : ""} style={{ margin: "0 auto", cursor: !isUpload ? "pointer" : "" }} onClick={isUpload ? undefined : () => urlShortningForDraft(ele)}>
                                {ele?.name}
                              </span>
                              {isUpload && <IoCloudUploadOutline onClick={() => handleUploadNew(ele)} style={{ fontSize: "18px", cursor: "pointer", marginLeft: "5px" }} />}
                              {!isUpload && (
                                <Dropdown overlay={<MenuItem ele={ele} isUpload={isUpload} origin="upload" />} trigger={["click", "hover"]}>
                                  <MoreOutlined style={{ cursor: "pointer", fontSize: "26px", strokeWidth: "2", color: "#085190" }} />
                                </Dropdown>
                              )}
                            </div>
                          </td>
                          <td>
                            {(ele?.signatureSequence?.[0]?.buyer && ele?.isAllBuyerSigned) || ele?.signatureOf?.includes("BUYER")
                              ? "✔️"
                              : !isUpload && (!ele?.signatureSequence?.[0]?.buyer || ele?.signatureOf?.includes("BUYER"))
                                ? "n/a"
                                : ""}
                          </td>
                          <td>
                            {(ele?.signatureSequence?.[0]?.buyerAgent && ele?.isAllBuyerAgentsSigned) || ele?.signatureOf?.includes("BUYER_AGENT")
                              ? "✔️"
                              : !isUpload && (!ele?.signatureSequence?.[0]?.buyerAgent || ele?.signatureOf?.includes("BUYER_AGENT"))
                                ? "n/a"
                                : ""}
                          </td>
                          <td>
                            {(ele?.signatureSequence?.[0]?.seller && ele?.isAllSellerSigned) || ele?.signatureOf?.includes("SELLER")
                              ? "✔️"
                              : !isUpload && (!ele?.signatureSequence?.[0]?.seller || ele?.signatureOf?.includes("SELLER"))
                                ? "n/a"
                                : ""}
                          </td>
                          <td>
                            {(ele?.signatureSequence?.[0]?.sellerAgent && ele?.isAllSellerAgentsSigned) || ele?.signatureOf?.includes("SELLER_AGENT")
                              ? "✔️"
                              : !isUpload && (!ele?.signatureSequence?.[0]?.sellerAgent || ele?.signatureOf?.includes("SELLER_AGENT"))
                                ? "n/a"
                                : ""}
                          </td>

                          <td className={styles.symbolsColumn}>{ele ? getStatusIcon(ele, isUpload) : ""}</td>
                        </tr>
                      );
                    }
                    return (
                      <tr key={ele.contractId}>
                        <td>{ele?.createdAt ? moment(ele?.createdAt)?.format("MM/DD/YYYY hh:mm A") : ele?.createdAt ? moment(ele?.createdAt)?.format("MM/DD/YYYY hh:mm A") : ""}</td>
                        <td>{ele?.signaturesVerifiedAt ? moment(ele?.signaturesVerifiedAt)?.format("MM/DD/YYYY hh:mm A") : ""}</td>
                        <td>
                          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            {ele.fileType === "IMAGE" ? (
                              <FileImageOutlined
                                style={{
                                  color: "#ecd540",
                                  marginTop: "5px",
                                  marginRight: "5px",
                                  fontSize: "18px",
                                }}
                              />
                            ) : ele.fileType === "PDF" || ele.pdfLink || ele?.fileUrl ? (
                              <FaRegFilePdf
                                style={{
                                  color: "red",
                                  marginTop: "5px",
                                  marginRight: "5px",
                                  fontSize: "18px",
                                }}
                              />
                            ) : (
                              <FileTextOutlined
                                style={{
                                  color: "#74b3ed",
                                  marginRight: "5px",
                                  fontSize: "18px",
                                }}
                              />
                            )}
                            <span className={ele?.isPropertyDoc ? styles.documentName : ""} style={{ margin: "0 auto", cursor: ele?.isPropertyDoc ? "pointer" : "" }} onClick={ele?.isPropertyDoc ? () => urlShortningForDraft(ele) : undefined}>{ele?.name || ele?.fileName}</span>
                            {isUpload && <IoCloudUploadOutline onClick={() => handleUploadNew(ele)} style={{ fontSize: "18px", cursor: "pointer" }} />}
                            {!isUpload && <Dropdown overlay={<MenuItem ele={ele} origin="add" />} trigger={["click", "hover"]}>
                              <MoreOutlined style={{ cursor: "pointer", fontSize: "26px", strokeWidth: "2", color: "#085190" }} />
                            </Dropdown>}

                          </div>
                        </td>
                        <td>
                          {(ele?.signatureOf?.includes("BUYER")) ? "✔️" : "n/a"}
                        </td>
                        <td>
                          {(ele?.signatureOf?.includes("BUYER_AGENT"))
                            ? "✔️"
                            : "n/a"}
                        </td>
                        <td>
                          {(ele?.signatureOf?.includes("SELLER")) ? "✔️" : "n/a"}
                        </td>
                        <td>
                          {(ele?.signatureOf?.includes("SELLER_AGENT"))
                            ? "✔️"
                            : "n/a"}
                        </td>
                        <td className={styles.symbolsColumn}>
                          {ele?.signaturesVerified ? getStatusIcon(ele) : ""}
                        </td>
                      </tr>
                    );
                  })}
                  <tr style={{ textAlign: "left" }}>
                    <td></td>
                    <td></td>
                    <td>
                      <Button style={{ margin: "5px 10px" }} type='primary' onClick={handleAddDocument}>Add Document</Button>
                    </td>
                    <td colSpan={5}></td>
                  </tr>
                </tbody>


                {showPropertyDocUpload && <Modal
                  title={<span style={{ display: "flex", justifyContent: "center", color: "#178DFA", fontWeight: "bold", fontSize: "22px" }}>Add Documents</span>}
                  visible={true}
                  width={770}
                  bodyStyle={{ height: "calc(80vh - 3rem)" }}
                  onCancel={handleClose}
                  footer={false}
                >
                  <Tabs defaultActiveKey="propertyDocs" style={{ marginTop: "-25px" }}>
                    <TabPane tab="Property Docs" key="propertyDocs">
                      {propertDocsLoading ? <Loading /> :
                        <>
                          <div style={{ textAlign: "center", height: "calc(80vh - 10rem)", overflowY: "auto" }}>
                            <PropertyDocsTable origin={"checklistTable"} propertyDocs={propertyDocs} role={client} item={item} handleShowInChecklist={handleShowInChecklist} checkboxSelected={checkboxSelected} setCheckboxSelected={setCheckboxSelected} />
                          </div>
                          {checkboxSelected?.length > 0 && <div style={{ display: "flex", justifyContent: "center", marginBottom: 8 }}>
                            <Button type="primary" onClick={handleShowInChecklist}>
                              Apply
                            </Button>
                          </div>}
                        </>
                      }
                    </TabPane>
                    <TabPane tab="Upload" key="upload">
                      <PropertyDocsDragger handleClose={handleClose} item={{ ...item, ...((client === "SELLER") ? { isProperty: true } : { isOffer: true }) }} delegate={delegate} additionalData={{ showInChecklist: true }} origin={"checklistTable"} />
                    </TabPane>
                  </Tabs>
                </Modal>}
              </table>


              <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "1rem", borderBottom: "1px solid #ccc", marginTop: "20px" }}>
                <div>Commission Distribution Report from Sale ({client === "SELLER" ? "Seller's" : "Buyer's"} Agent)</div>
                <div>{transactionReportData?.address}</div>
              </div>
              <div >
                <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                  <div
                    style={{
                      display: "flex",
                      borderRadius: "8px",
                      overflow: "hidden",
                      width: "100%",
                      margin: "auto",
                      gap: "1px",
                    }}
                  >
                    {/* Seller Agents */}
                    <div style={{ flex: 1, padding: "16px", backgroundColor: "#f9f9f9" }}>
                      <div style={{ color: "grey", fontWeight: "bold", marginBottom: "12px", textAlign: "center" }}>
                        {client === "SELLER" ? "Selling" : "Buying"} Agent
                      </div>

                      {(client === "SELLER" ? transactionReportData?.sellerAgents : transactionReportData?.buyerAgents)?.map((agent, idx) => (
                        <div
                          key={`seller-${idx}`}
                          style={{
                            border: "1px solid #ddd",
                            borderRadius: "6px",
                            padding: "10px",
                            marginBottom: "16px",
                            backgroundColor: "#fff",
                          }}
                        >
                          {[
                            { label: "Brokerage Name:", value: agent?.firmName },
                            { label: "Brokerage ID:", value: agent?.firmLicense },
                            { label: "Address:", value: agent?.address },
                            { label: "Agent:", value: agent?.fullName },
                            { label: "Agent ID:", value: agent?.license },
                            { label: "Phone:", value: agent?.phoneNumber },
                            { label: "Fax:", value: agent?.faxNumber },
                            { label: "Email:", value: agent?.email },
                          ].map((field, index) => (
                            <div key={index} style={{ display: "flex", marginBottom: "6px" }}>
                              <span style={{ fontWeight: "bold", width: "140px", flexShrink: 0 }}>
                                {field.label}
                              </span>
                              <span>{field.value || ""}</span>
                            </div>
                          ))}
                        </div>
                      )
                      )}
                    </div>

                    {/* Divider */}
                    <div style={{ width: "1px", backgroundColor: "#ccc" }}></div>

                    <div style={{ flex: 1, padding: "16px", backgroundColor: "#f9f9f9" }}>
                      <div style={{ color: "grey", fontWeight: "bold", marginBottom: "12px", textAlign: "center" }}>
                        Referring Agent (optional)
                      </div>

                      <Form
                        form={referralForm}
                        layout="horizontal"
                        onValuesChange={(values) => setAgent({ ...agent, referralSave: true })}
                        onFinish={handleReferralAgent}
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 16 }}
                      >
                        <div
                          style={{
                            border: "1px solid #ddd",
                            borderRadius: "6px",
                            padding: "5px",
                            marginBottom: "16px",
                            backgroundColor: "#fff",
                          }}
                        >
                          <Form.Item
                            label={<span style={{ fontSize: "14px" }}>Brokerage Name:</span>}
                            name="firmName"
                            style={{ marginBottom: "5px" }}
                          >
                            <Input />
                          </Form.Item>

                          <Form.Item
                            label={<span style={{ fontSize: "14px" }}>Brokerage ID:</span>}
                            name="firmLicense"
                            style={{ marginBottom: "5px" }}
                          >
                            <Input />
                          </Form.Item>

                          <Form.Item
                            label={<span style={{ fontSize: "14px" }}>Address:</span>}
                            name="address"
                            style={{ marginBottom: "5px" }}
                          >
                            <Input />
                          </Form.Item>

                          <Form.Item
                            label={<span style={{ fontSize: "14px" }}>Agent:</span>}
                            name="fullName"
                            style={{ marginBottom: "5px" }}
                          >
                            <Input />
                          </Form.Item>

                          <Form.Item
                            label={<span style={{ fontSize: "14px" }}>Agent ID:</span>}
                            name="license"
                            style={{ marginBottom: "5px" }}
                          >
                            <Input />
                          </Form.Item>

                          <Form.Item
                            label={<span style={{ fontSize: "14px" }}>Phone:</span>}
                            name="phoneNumber"
                            style={{ marginBottom: "5px" }}
                          >
                            <PhoneInput
                              inputStyle={{
                                width: "100%",
                              }}
                              inputClass="phoneInput"
                              country={"us"}
                              onlyCountries={["us"]}
                              maxLength="10"
                              international={false}
                              disableCountryCode={true}
                              placeholder=""
                            />
                          </Form.Item>

                          <Form.Item
                            label={<span style={{ fontSize: "14px" }}>Fax:</span>}
                            name="faxNumber"
                            style={{ marginBottom: "5px" }}
                          >
                            <PhoneInput
                              inputStyle={{
                                width: "100%",
                              }}
                              inputClass="phoneInput"
                              country={"us"}
                              onlyCountries={["us"]}
                              maxLength="10"
                              international={false}
                              disableCountryCode={true}
                              placeholder=""
                            />
                          </Form.Item>

                          <Form.Item
                            label={<span style={{ fontSize: "14px" }}>Email:</span>}
                            name="email"
                            style={{ marginBottom: "5px" }}
                          >
                            <Input />
                          </Form.Item>
                        </div>
                        <Form.Item style={{ display: "flex", justifyContent: "center" }}>
                          <Button type="primary" htmlType="submit" disabled={!agent?.referralSave}>
                            Save
                          </Button>
                        </Form.Item>
                      </Form>


                    </div>
                  </div>

                </div>

              </div>



              <div style={{ padding: '15px', width: "70%" }}>
                <Form form={form} initialValues={{sourceOfBusiness: checkListDataOnOffer?.sourceOfBusiness?.value}}>
                  <Form.Item label="Source Of Business" name="sourceOfBusiness">
                    <Select
                      labelInValue
                      onChange={handleSourceSelect}
                      loading={sourceOfBusinessLoading}
                      notFoundContent={
                        sourceOfBusinessLoading ? <Loading /> : <EmptyData />
                      }
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {sourceOfBusinessData?.map((element, index) => (
                        <Option key={index} value={element.key}>
                          {element.value}
                        </Option>
                      ))
                      }
                    </Select>
                  </Form.Item>
                </Form>
              </div>



              <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "1rem", borderBottom: "1px solid #ccc", color: "white", background: "#2270B9" }}>
                DATES
              </div>
              <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                <table style={{ textAlign: "center", width: "100%", border: "1px solid black" }}>
                  <thead style={{ backgroundColor: "antiquewhite" }}>
                    <tr>
                      <th style={{ padding: "8px 16px" }}>Opening Date</th>
                      <th style={{ padding: "8px 16px" }}>Under Contract</th>
                      <th style={{ padding: "8px 16px" }}>Closing Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{transactionReportData?.openingDate}</td>
                      <td>{""}</td>
                      <td>{item?.newTransactionData?.ClosingDate}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "1rem", borderBottom: "1px solid #ccc", color: "white", background: "#2270B9", marginTop: "20px" }}>
                COMMISSION DISTRIBUTION
              </div>

              <Form form={commissionForm} onFinish={handleCommission} onValuesChange={(values) => setAgent({ ...agent, commissionSave: true })} layout="horizontal" style={{ padding: "5px", width: "60%" }} labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}>
                <Form.Item
                  label={<span style={{ fontSize: "14px" }}>Sales Price</span>}
                  name="salePrice"
                >
                  <NumberFormat
                    className="newNumberInput"
                    inputmode="numeric"
                    displayType={"number"}
                    thousandSeparator={true}
                    prefix={"$ "}
                    suffix={".00"}
                    allowNegative={false}
                  />
                </Form.Item>

                <Form.Item
                  label={<span style={{ fontSize: "14px" }}>Gross Commission</span>}
                  name="grossCommission"
                >
                  <NumberFormat
                    className="newNumberInput"
                    inputmode="numeric"
                    displayType={"number"}
                    thousandSeparator={true}
                    prefix={"$ "}
                    suffix={".00"}
                    allowNegative={false}
                  />
                </Form.Item>

                <Form.Item
                  label={<span style={{ fontSize: "14px" }}>Referral</span>}
                  name="referral"
                >
                  <NumberFormat
                    className="newNumberInput"
                    inputmode="numeric"
                    displayType={"number"}
                    thousandSeparator={true}
                    prefix={"$ "}
                    suffix={".00"}
                    allowNegative={false}
                  />
                </Form.Item>

                <Form.Item
                  label={<span style={{ fontSize: "14px" }}>Charitable Contribution</span>}
                  name="charitableContribution"
                >
                  <NumberFormat
                    className="newNumberInput"
                    inputmode="numeric"
                    displayType={"number"}
                    thousandSeparator={true}
                    prefix={"$ "}
                    suffix={".00"}
                    allowNegative={false}
                  />
                </Form.Item>

                <Form.Item
                  label={<span style={{ fontSize: "14px" }}>Charity 1</span>}
                  name="charity_1"
                >
                  <NumberFormat
                    className="newNumberInput"
                    inputmode="numeric"
                    displayType={"number"}
                    thousandSeparator={true}
                    prefix={"$ "}
                    suffix={".00"}
                    allowNegative={false}
                  />
                </Form.Item>

                <Form.Item
                  label={<span style={{ fontSize: "14px" }}>Charity 2</span>}
                  name="charity_2"
                >
                  <NumberFormat
                    className="newNumberInput"
                    inputmode="numeric"
                    displayType={"number"}
                    thousandSeparator={true}
                    prefix={"$ "}
                    suffix={".00"}
                    allowNegative={false}
                  />
                </Form.Item>
                <Form.Item style={{ display: "flex", justifyContent: "center" }}>
                  <Button type="primary" htmlType="submit" disabled={!agent?.commissionSave}>
                    Save
                  </Button>
                </Form.Item>
              </Form>

            </> : <EmptyData />}
      </Modal>
    </>
  )
}

export default ChecklistTable
